import './application/main'

import '../../vendor/assets/javascripts/tooltipster.bundle.min'

import 'slick-carousel/slick/slick'
import 'chart.js/dist/Chart.min'
import 'zebra_datepicker/dist/zebra_datepicker.min'
import 'jquery.counterup'
import 'waypoints/lib/jquery.waypoints.min'
import '../../vendor/assets/javascripts/cocoon'
import Rails from '@rails/ujs'

Rails.start()

import './application/app'
import './application/cancel_investment'
import './application/comparator'
import './application/favorites'
import './application/footer'
import './application/form'
import './application/fund_places'
import './application/graph'
import './application/header'
import './application/home'
import './application/investment_funds'
import './application/investment'
import './application/modal'
import './application/newsletter'
import './application/offers'
import './application/orias_number'
import './application/payment'
import './application/radio'
import './application/search'
import './application/select_multiple'
import './application/simulator'
import './application/tabs'

import './application/shared/file'
import './application/shared/select2'